var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatmapWidgetLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 49,
    viewBox: "0 0 84 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 49,
    rx: 8,
    fill: "#C5D0E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 76,
    height: 41,
    rx: 4,
    fill: "#E8EDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L20 38",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.6729H18",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.6729H18",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.6729H18",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28.6729H18",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 31.6729L18 31.6729",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 34.6729H18",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 37.6729L18 37.6729",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.6729L18 25.6729",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.6729L18 19.6729",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.6729L18 13.6729",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 14,
    width: 17,
    height: 8,
    fill: "#FF6565"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 17,
    height: 8,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 17,
    height: 8,
    fill: "#5F5CF6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55.8037,
    y: 30,
    width: 17,
    height: 8,
    fill: "#FF6565"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8037,
    y: 22,
    width: 17,
    height: 8,
    fill: "#5F5CF6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8037,
    y: 30,
    width: 17,
    height: 8,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmapWidgetLight);
export default __webpack_public_path__ + "static/media/heatmap-widget-light.b7f3493e2d1d778cdd6d966cd00a3cbc.svg";
export { ForwardRef as ReactComponent };